module.exports = __webpack_public_path__ + "img/icon_set.de442ffb.svg";